(function CruiseSearchResults($, Adzuki)
{
	"use strict";
	$(document).ready(function documentReady()
	{
		var cruiseSearchPages = ['/CruiseSearch/results', '/CruiseSearch/view', '/Deals/view'];

		Adzuki.onload(cruiseSearchPages, function onload()
		{
			var is_afc = $('.search-results').data("afc"),
				advanced_button = $('aside#search .btn-advanced');

			if (is_afc && is_afc.length === 0) {
				advanced_button.removeClass('hidden');

				advanced_button.click(function advancedButton(e) {
					e.preventDefault();
					window.location.href = Adzuki.base_uri + '/CruiseSearch/AdvancedSearch/1';
				});
			}

			$('.alt-dates').click(function showAlternateSailingDates(e) {
				var itinerary_id    = $(this).data("itinerary-id"),
					itinerary_title = $(this).data("itinerary-title"),
					$modal          = $(".modal");

				e.preventDefault();

				$(".modal-dialog").addClass('modal-lg');
				$modal.find('.modal-body').text('Loading Alternate Sailing Dates...');

				Adzuki.Ajax.get('/CruiseSearch/alternateSailings/' + itinerary_id).then(function success(response) {
					$modal.find('.modal-body').html(response);
				});

				$modal.find('.modal-title').text(itinerary_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

		}, false);

		$('.city-details').click(function cityClicked(e) {
			var $self    = $(this),
			    $city_id = $self.data("id");

			e.preventDefault();

			$(".modal-body").html('');
			$(".modal-dialog").addClass('modal-lg');

			Adzuki.Ajax.get('/Cities/view/' + $city_id)
				.then(function populateModal(content) {
					$(".modal-title").text('City Details');
					$('.modal-body').html(content);
					$('#modalLabel').html($self.data("name"));
			});

			$('.modal').modal('show');

		});

		$('.shore-excursion-link').click(function excursionLinkClicked(e) {
			var $self         = $(this),
			    $itinerary_id = $self.data("itinerary-id");

			e.preventDefault();

			$(".modal-dialog").addClass('modal-lg');
			$(".modal-title").text('Shore Excursions');
			$(".modal-body").html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading excursions...');

			Adzuki.Ajax.get('/Excursions/getByItineraryId/' + $itinerary_id)
				.then(function populateModal(content) {
					$('.modal-body').html(content);
					$('#modalLabel').html($self.data("name"));
			});

			$('.modal').modal('show');
		});

		$('.offer-link').click(function offerLinkClicked(e) {
			var $self        = $(this),
			    $offer_id    = $self.data("id"),
			    $offer_title = $self.data("title");

			e.preventDefault();

			Adzuki.Ajax.get('/CruiseSearch/offerDetails/' + $offer_id)
				.then(function populateModal(content) {
					$(".modal-dialog").addClass('modal-lg');
					$(".modal-title").text($offer_title);
					$('.modal-body').html(content);
			});

			$('.modal').modal('show');
		});

		$('.special-link').click(function specialLinkClicked(e) {
			var $self     = $(this),
			    $special_id = $self.data("id");

			e.preventDefault();

			Adzuki.Ajax.get('/CruiseSearch/specialDetails/' + $special_id)
				.then(function populateModal(content) {
					$(".modal-dialog").addClass('modal-lg');
					$(".modal-title").text('Offer Details');
					$('.modal-body').html(content);
			});

			$('.modal').modal('show');
		});

		// $(document).on('click', '.result-group-details', function showGroupDetails(e) {
		$('.result-group-details').click(function groupLinkClicked(e) {
			var group_id = $(this).data("group-id"),
				$modal   = $(".modal"),
				url      = '/GroupsHo/detail/' + group_id;

			e.preventDefault();

			$(".modal-dialog").addClass('modal-lg');
			$modal.find('.modal-body').text('Loading Cruise Planners Exclusive Details...');

			Adzuki.Ajax.get(url)
			.then(function success(html) {
				$modal.find('.modal-body').html(html);
				$modal.find('[data-toggle^="tooltip"]').tooltip();
			});

			$modal.find('.modal-title').text('Cruise Planners Exclusive Pricing');
			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		});

		$('.result-groups-details').click(function groupsLinkClicked(e) {
			var itinerary_id = $(this).data("itinerary-id"),
				$groupModal   = $(".modal"),
				url   = '/Groups/groups/' + itinerary_id;

			e.preventDefault();

			$(".modal-dialog").addClass('modal-lg');
			$groupModal.find('.modal-body').text('Loading Cruise Planners Exclusive Details...');

			Adzuki.Ajax.get(url)
				.then(function success(html) {
					$groupModal.find('.modal-body').html(html);
					$groupModal.find('[data-toggle^="tooltip"]').tooltip();
				});

			$groupModal.find('.modal-title').text('Cruise Planners Exclusive Pricing');
			$groupModal.on('hidden.bs.modal', function _restoreModal() {
				$groupModal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		});

		$('.modal').on('click', '.port-link', function scrollTo(e) {
			var el        = $(this).attr('href'),
			    scroll_to = $(el);

			e.preventDefault();

			$('.modal').animate({
			    scrollTop: (scroll_to.offset().top - $('.modal').offset().top)
			}, 500);

		});

		$('.modal').on('click', '.excursion-modal', function showModal(e) {
			var content = $(this).find(".content").html(),
				title   = $(this).data("title");

			e.preventDefault();

			$.alert({
				title  : title,
				content: content
			});
		});

		$('body').on('click', '.seg-excursion', function showSegInModal(e) {
			var $self     = $(this),
			    code      = $self.data("code"),
			    $content  = $self.closest(".search-result").find(".hidden-content"),
			    populated = $content.attr('data-populated'),
			    $ani      = $content.find('.exc-loader');

			e.preventDefault();

			$content.toggleClass('hidden');

			// check to see if we already made an ajax call to get the excursion details
			if (populated !== '0') {
				return;
			}

			Adzuki.Ajax.get('/Excursions/getByCode/' + code)
				.then(function _showExcursionDeets(response) {
					var rows = '',
					    arr  = {};

					if (response) {
						arr = {
								Description        : response.description,
								"Private Tour"     : (response.private_tour === true) ? 'Y' : 'N',
								// Code               : json.code,
								Size               : response.features.size,
								Type               : response.features.type,
								"Departs From"     : response.features.departs_from,
								"Activity Level"   : response.features.activity_level,
								"Food & Beverage"  : response.features.food_beverage,
								"Recommended Dress": response.features.recommended_dress,
								Restrictions       : response.features.restrictions
						};

						$.each(arr, function detailsLoop( index, value ) {
							if (value !== undefined) {
								rows += '<p class="pad10-vert"><strong class="badge">' + index + '</strong>' + value + '</p>';
							}
						});
					} else {
						rows += '<tr><td>Additional Excursion Details Currently Unavailable</td></tr>';
					}

					$content.html(rows);
					$content.attr('data-populated', '1');
					$ani.hide();
			});
		});

		$('.btn-filter').click(function showFilter(e) {
			e.preventDefault();

			if ($('.cruise-filter').is(":visible")) {
				$('.cruise-filter').slideUp();
			} else {
				$('.cruise-filter').slideDown();
			}
		});

		$('.close-filter').click(function closeFilter(e) {
			e.preventDefault();

			$('.cruise-filter').slideUp();
		});

		$('.share-search').click(function shareSearch(e) {
			var afc = $(this).data('afc');

			e.preventDefault();
			$(".modal-title").text('Share Search Results');
			$(".modal-dialog").addClass('modal-lg');
			Adzuki.Ajax.get('/CruiseSearch/share/'+ afc)
				.then(function populateModal(content) {
					$('.modal-body').html(content);
			});

			$('.modal').modal('show');
		});

		$('.modal').on('click', '.copy-to-clipboard-link', function copyIt(e) {
			var $self = $(this),
			    url   = $self.data("url");

			e.preventDefault();

			$('#link').val(url).select();
				document.execCommand('copy');

			Adzuki.StatusMessage('Success', 'The link has been copied to your clipboard.');
		});

		$('.modal').on('click', '.group-category', function appendIt(e) {
			var categories        = '',
			    original_href     = $('.group-request-info').data('url');

			$('.group-category').each(
				function checkUncheckAll(index, el) {
					if ($(el).prop('checked') === true) {
						console.log($(el).val());
						categories = categories + $(el).val() + '-' + $(el).data('group') + '-' + $(el).data('type') + '|';
					}
				}
			);

			console.log(categories);
			$('.group-request-info').attr('href', original_href + '/' + categories);
		});

		$('.in-page-anchor').click(function closeHeader(e) {
			e.preventDefault();

			// don't immediately show the header
			$('#ignore_display_header').val('1');

			$([document.documentElement, document.body]).animate({
				scrollTop: $("#guide").offset().top
			 }, 250);

			// allow the page to show the header upon manual scrolling up
			setTimeout(function hideTop() {
				$('#ignore_display_header').val('0');
			}, 1200);

		});
	});
}(jQuery, window.Adzuki || {}));
